/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mail_Admin_Recipient_RequiredInputs */

const en_mail_admin_recipient_required = /** @type {(inputs: Mail_Admin_Recipient_RequiredInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Please select a recipient.`)
};

const de_mail_admin_recipient_required = /** @type {(inputs: Mail_Admin_Recipient_RequiredInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bitte wählen Sie einen Empfänger aus.`)
};

/**
* | output |
* | --- |
* | "Please select a recipient." |
*
* @param {Mail_Admin_Recipient_RequiredInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const mail_admin_recipient_required = /** @type {((inputs?: Mail_Admin_Recipient_RequiredInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mail_Admin_Recipient_RequiredInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_mail_admin_recipient_required(inputs)
	return en_mail_admin_recipient_required(inputs)
});